import { findObjectUseCase } from "../../../../usecases/object";
export const getAssignAirport = async (objects, datePicked) => {
  let ids = objects.map((emp) => emp.id);

  const where = {};
  if (datePicked?.startDate && datePicked?.endDate) {
    const pickedStart = new Date(datePicked.startDate);
    const pickedEnd = new Date(datePicked.endDate);
    
    pickedEnd.setHours(23, 59, 59, 999);
    
    where.$and = [
      { startDate: { $lte: pickedEnd.toISOString() } },
      { endDate: { $gte: pickedStart.toISOString() } }
    ];
  }


  const query = {
    include: ["assignRelation", "assignRelation.employee"],
  };

  if (Object.keys(where).length > 0) {
    query.where = where;
  }

  const airportAssigned = await findObjectUseCase().execute(
    "airport_assign",
    query,
  );

  const idSet = new Set(ids);
  const filteredEmployeeDuty = airportAssigned.filter((item) =>
    item.assignRelation?.some(
      (relation) => relation.employee && idSet.has(relation.employee.id)
    )
  );

  const result = {};
  const assignObject = {}

  for (const item of filteredEmployeeDuty) {
    const start = new Date(item.startDate);
    const end = new Date(item.endDate);
    const timeDiff = Math.abs(end - start);
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;

    for (const relation of item?.assignRelation ?? []) {
      const emp = relation?.employee;

      if (emp && ids.includes(emp.id)) {
        result[emp.id] = days;
        assignObject[emp.id] = {assignedArea: relation?.assignedArea, twentyFourSeven: relation?.twentyFourSeven};
      }
    }
  }
  
  return {
    result,
    filteredEmployeeDuty,
    assignObject,
  };
};

export const getMonthIndex = (selectedDate) => {
  if (!selectedDate?.startDate) return;

  const start = new Date(selectedDate?.startDate);
  const month = start.getMonth();

  return 12 - month;
};
